webpackJsonp([71],{

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1273);


/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(174);

var _datetime2 = _interopRequireDefault(_datetime);

var _pt = __webpack_require__(780);

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('pt', _pt2.default);

/***/ })

},[1272]);


// WEBPACK FOOTER //
// app/datetime.pt-3e5d05b06e620cb65904.js